import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-sgkb714d',
  templateUrl: './sgkb714d.component.html',
  styleUrl: './sgkb714d.component.scss'
})
export class Sgkb714dComponent implements OnInit, OnDestroy {

  priceInputForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder
  ) {
    this.priceInputForm = this.fb.group({});
  }

  /**
   * 初期処理
   * @memberof Sgkb714dComponent
   */
  ngOnInit(): void {

  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb714dBulksetComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.priceInputForm.clearValidators();
    this.priceInputForm.updateValueAndValidity();
    this.priceInputForm.removeControl('priceInputForm');
  }


  /**
   * サブミット処理
   * @memberof Sgkb714dComponent
   */
  onSubmit(): void {

  }
}
